/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Verify_CrumbInputs */

const en_guest_verify_crumb = /** @type {(inputs: Guest_Verify_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking confirmation`)
};

const pl_guest_verify_crumb = /** @type {(inputs: Guest_Verify_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potwierdzenie rezerwacji`)
};

/**
* | output |
* | --- |
* | "Booking confirmation" |
*
* @param {Guest_Verify_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_verify_crumb = /** @type {((inputs?: Guest_Verify_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Verify_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_verify_crumb(inputs)
	return en_guest_verify_crumb(inputs)
});